import decode from 'jwt-decode';
import moment from 'moment';
import ApiClient from './ApiClient';

const TOKEN_KEY = 'token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || null;

export const clearToken = () => localStorage.setItem(TOKEN_KEY, null);

export const login = ({ username, password }) => {
  const client = ApiClient({ bypassAuthCheck: true });
  clearToken();
  return client
    .post('/auth', {
      username,
      password,
    })
    .then(resp => {
      localStorage.setItem(TOKEN_KEY, resp.data.token);
    });
};

export const loggedIn = () => {
  const token = getToken();
  if (!token) return false;
  let clear = false;

  try {
    const decoded = decode(token);
    if (decoded.exp && moment(decoded.exp * 1000).isSameOrBefore())
      clear = true;
  } catch (err) {
    clear = true;
  }

  if (clear) {
    clearToken();
    return false;
  }
  return true;
};

export const username = () => {
  const token = getToken();
  if (!token) return '';

  try {
    const decoded = decode(token);
    return decoded.username;
  } catch (err) {
    return '';
  }
};

export const decodeToken = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const decoded = decode(token);
    return decoded;
  } catch (err) {
    return null;
  }
};

export const getRole = () => {
  const token = getToken();
  if (!token) return '';

  try {
    const decoded = decode(token);
    return decoded.role;
  } catch (err) {
    return '';
  }
};

export const refreshToken = () => {
  const client = ApiClient({ bypassAuthCheck: true });
  const token = getToken();
  if (!token) return '';

  return client
    .post('/refresh_token', {
      token
    })
    .then(resp => {
      localStorage.setItem(TOKEN_KEY, resp.data.token);
    }); 
};

export default {
  login,
  loggedIn,
  username,
  getToken,
  clearToken,
  getRole,
  decodeToken,
};



// WEBPACK FOOTER //
// ./src/services/Auth.js